/*
 * Aléo Studio size guide — real graded garment measurements (cm; the
 * cm/in toggle in the panel converts to inches on the fly, cm / 2.54, so
 * there's only ever one set of numbers to keep correct).
 *
 * `rows_cm` is one row per size (same order as `sizes`), each row
 * [A, B, C, D] matching `columns` below. Computed from the Medium (M)
 * measurement plus a per-size step (3XS -4, XXS -3 ... XL +2) via this
 * grading:
 *   A Chest:    +/- 2.54 cm per step (1 inch total grade, flat/half
 *               measurement -- factory's 2 inch total grade / 2)
 *   B Length:   +/- 1.27 cm per step (1/2 inch per step)
 *   C Shoulder: held flat at the Medium value -- no grading rule yet
 *   D Sleeve:   +/- 0.635 cm per step (1/4 inch per step, the factory's
 *               own sleeve grade) -- EXCEPT T-shirt (Reo), which stays
 *               flat at the Medium value on request: that sleeve is
 *               short and doesn't grade by size.
 * C will need updating once the pattern maker sends real shoulder
 * grading; A, B and D (T-shirt aside) are the real factory grade.
 * Medium's own row is exactly the measurement the merchant gave
 * (sanity-checked against step 0 below).
 *
 * Keyed by garment type (see window.ALEO_SIZE_GUIDE_TITLE_MAP below for
 * how a product's own title maps to one of these keys). There's no
 * fallback/Default entry: a product whose title doesn't match any
 * keyword gets no Garment measurements tab at all rather than a guess
 * (assets/aleo-size-guide.js hides that tab and shows Size only).
 *
 * `diagram` names which inline SVG this garment type uses for the
 * Garment Measurements tab (snippets/aleo-size-guide-diagram-<diagram>.
 * liquid). `columns` labels match the lettering drawn into the sketches.
 */
window.ALEO_SIZE_GUIDE = {
  'T-shirt': {
    diagram: 'tshirt',
    sizes: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
    columns: [
      { label: 'A', name: 'Chest' },
      { label: 'B', name: 'Length' },
      { label: 'C', name: 'Shoulder' },
      { label: 'D', name: 'Sleeve' }
    ],
    rows_cm: [
      [46.8, 58.9, 45.0, 21.0],
      [49.4, 60.2, 45.0, 21.0],
      [51.9, 61.5, 45.0, 21.0],
      [54.5, 62.7, 45.0, 21.0],
      [57.0, 64.0, 45.0, 21.0],
      [59.5, 65.3, 45.0, 21.0],
      [62.1, 66.5, 45.0, 21.0]
    ]
  },
  Shirt: {
    diagram: 'shirt',
    sizes: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
    columns: [
      { label: 'A', name: 'Chest' },
      { label: 'B', name: 'Length' },
      { label: 'C', name: 'Shoulder' },
      { label: 'D', name: 'Sleeve' }
    ],
    rows_cm: [
      [54.8, 74.9, 58.0, 55.5],
      [57.4, 76.2, 58.0, 56.1],
      [59.9, 77.5, 58.0, 56.7],
      [62.5, 78.7, 58.0, 57.4],
      [65.0, 80.0, 58.0, 58.0],
      [67.5, 81.3, 58.0, 58.6],
      [70.1, 82.5, 58.0, 59.3]
    ]
  },
  Crewneck: {
    diagram: 'crewneck',
    sizes: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
    columns: [
      { label: 'A', name: 'Chest' },
      { label: 'B', name: 'Length' },
      { label: 'C', name: 'Shoulder' },
      { label: 'D', name: 'Sleeve' }
    ],
    rows_cm: [
      [51.8, 60.9, 58.0, 59.5],
      [54.4, 62.2, 58.0, 60.1],
      [56.9, 63.5, 58.0, 60.7],
      [59.5, 64.7, 58.0, 61.4],
      [62.0, 66.0, 58.0, 62.0],
      [64.5, 67.3, 58.0, 62.6],
      [67.1, 68.5, 58.0, 63.3]
    ]
  },
  'Half-Zip': {
    diagram: 'half-zip',
    sizes: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
    columns: [
      { label: 'A', name: 'Chest' },
      { label: 'B', name: 'Length' },
      { label: 'C', name: 'Shoulder' },
      { label: 'D', name: 'Sleeve' }
    ],
    rows_cm: [
      [49.8, 57.9, 62.0, 52.5],
      [52.4, 59.2, 62.0, 53.1],
      [54.9, 60.5, 62.0, 53.7],
      [57.5, 61.7, 62.0, 54.4],
      [60.0, 63.0, 62.0, 55.0],
      [62.5, 64.3, 62.0, 55.6],
      [65.1, 65.5, 62.0, 56.3]
    ]
  }
};

/*
 * Aléo sizing (men's) -> Women's equivalent, one size down -- same
 * conversion regardless of garment type, shown on the Size tab. Real
 * values, not placeholders (per the brief: Aléo runs men's sizing,
 * women's is one size smaller). The "Men's equivalent" row the Size tab
 * shows is identical to `aleo` -- it's the same scale, just labeled so
 * both the Aléo Studio size and its men's-sizing equivalent are visible
 * on one row each.
 *
 * The mapping is mechanical: both rows sit on one shared XXS...XXL
 * letter scale, and `womens[i]` is always exactly one step up that
 * scale from `aleo[i]` (XXS->XS, XS->S, ... XL->XXL). 3XS was added on
 * the same rule -- one step further down than XXS, so its women's
 * equivalent is XXS.
 */
window.ALEO_SIZE_CONVERSION = {
  aleo: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
  womens: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']
};

/*
 * Product TITLE (not product.type -- the catalog's type values, e.g.
 * "T-Shirt"/"Top"/"Sweater"/"Bottoms"/"Bottom", are too generic to
 * decide a garment shape from) -> which key above to use. Matching is
 * case-insensitive, one keyword per anchor top. Edit this list as new
 * anchor tops are added; a title that matches nothing gets no Garment
 * measurements tab at all (see window.aleoResolveSizeGuideType) rather
 * than a guessed one.
 */
window.ALEO_SIZE_GUIDE_TITLE_MAP = [
  { test: /reo/i, key: 'T-shirt' },
  { test: /arlit/i, key: 'Shirt' },
  { test: /kayes/i, key: 'Crewneck' },
  { test: /sah/i, key: 'Half-Zip' }
];

window.aleoResolveSizeGuideType = function (productTitle) {
  var title = (productTitle || '').trim();
  for (var i = 0; i < window.ALEO_SIZE_GUIDE_TITLE_MAP.length; i++) {
    if (window.ALEO_SIZE_GUIDE_TITLE_MAP[i].test.test(title)) {
      return window.ALEO_SIZE_GUIDE_TITLE_MAP[i].key;
    }
  }
  return null;
};
